enum TagViewTabPaths {
  Videos = 'videos',
  Metrics = 'metrics',
}

export default TagViewTabPaths;
